import { Union, Record } from "../fable_modules/fable-library.3.7.12/Types.js";
import { lambda_type, unit_type, array_type, list_type, class_type, union_type, string_type, obj_type, enum_type, record_type, bool_type, int32_type } from "../fable_modules/fable-library.3.7.12/Reflection.js";
import { AnatomicalRegionLabelViewModel } from "../Optiscan.Models/View/AnatomicalRegion.js";

export class ViewerContext extends Record {
    constructor(currentFrame, stopped) {
        super();
        this.currentFrame = (currentFrame | 0);
        this.stopped = stopped;
    }
}

export function ViewerContext$reflection() {
    return record_type("Client.Telepathology.Bindings.ViewerContext", [], ViewerContext, () => [["currentFrame", int32_type], ["stopped", bool_type]]);
}

export class ControlMessageRaw extends Record {
    constructor(MessageType, Data) {
        super();
        this.MessageType = (MessageType | 0);
        this.Data = Data;
    }
}

export function ControlMessageRaw$reflection() {
    return record_type("Client.Telepathology.Bindings.ControlMessageRaw", [], ControlMessageRaw, () => [["MessageType", enum_type("Client.Telepathology.Bindings.ControlMessageType", int32_type, [["Unpaused", 0], ["Paused", 1], ["Stopped", 2], ["KeepAlive", 3], ["SessionStarted", 4], ["SessionCompleted", 5]])], ["Data", obj_type]]);
}

export class UnpausedMessageData extends Record {
    constructor(streamPath, anatomicalRegionSite, sequenceName) {
        super();
        this.streamPath = streamPath;
        this.anatomicalRegionSite = anatomicalRegionSite;
        this.sequenceName = sequenceName;
    }
}

export function UnpausedMessageData$reflection() {
    return record_type("Client.Telepathology.Bindings.UnpausedMessageData", [], UnpausedMessageData, () => [["streamPath", string_type], ["anatomicalRegionSite", string_type], ["sequenceName", string_type]]);
}

export function UnpausedMessageData_toViewModel_Z442EF4F(data) {
    return new AnatomicalRegionLabelViewModel(data.streamPath);
}

export class ControlMessage extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UnpausedMessage", "PausedMessage", "StoppedMessage", "SessionStartedMessage", "SessionCompletedMessage"];
    }
}

export function ControlMessage$reflection() {
    return union_type("Client.Telepathology.Bindings.ControlMessage", [], ControlMessage, () => [[["Item", UnpausedMessageData$reflection()]], [], [], [], []]);
}

export function ControlMessage_tryFromRaw_4A75406F(raw) {
    const matchValue = raw.MessageType | 0;
    switch (matchValue) {
        case 0: {
            return new ControlMessage(0, raw.Data);
        }
        case 1: {
            return new ControlMessage(1);
        }
        case 2: {
            return new ControlMessage(2);
        }
        case 3: {
            return void 0;
        }
        case 4: {
            return new ControlMessage(3);
        }
        case 5: {
            return new ControlMessage(4);
        }
        default: {
            return void 0;
        }
    }
}

export class CanvasLayoutConfig extends Record {
    constructor(isInForm) {
        super();
        this.isInForm = isInForm;
    }
}

export function CanvasLayoutConfig$reflection() {
    return record_type("Client.Telepathology.Bindings.CanvasLayoutConfig", [], CanvasLayoutConfig, () => [["isInForm", bool_type]]);
}

export class ILiveTelepathologyProps extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SignalingClient", "PeerConnection", "DataChannels", "LayoutConfig", "CanvasIds", "OnDroppedFrame", "OnImageFlag", "OnControlMessage", "DebugTeleStats"];
    }
}

export function ILiveTelepathologyProps$reflection() {
    return union_type("Client.Telepathology.Bindings.ILiveTelepathologyProps", [], ILiveTelepathologyProps, () => [[["Item", class_type("Fable.Import.Aws.SignalingClient.SignalingClient")]], [["Item", class_type("Browser.Types.RTCPeerConnection", void 0, RTCPeerConnection)]], [["Item", list_type(class_type("Browser.Types.RTCDataChannel", void 0, RTCDataChannel))]], [["Item", CanvasLayoutConfig$reflection()]], [["Item", array_type(string_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(ViewerContext$reflection(), unit_type)]], [["Item", lambda_type(ControlMessageRaw$reflection(), unit_type)]], [["Item", bool_type]]]);
}

